<template>
  <a style="cursor: pointer" @click.prevent="helper.copy($el, value, id)">
    <span class="subtext copied-text-absolute" :class="{show: helper.copyHintVisible(id)}">{{ helper.trans("labels.copied") }}</span>
    <i class="fa-regular fa-copy"></i>
  </a>
</template>

<script lang="ts">

import {defineComponent, Prop, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";

export default defineComponent({
  props: {
    value: {
      default: ''
    } as Prop<string|number|any>,
  },
  setup(props) {

    const state = reactive({
      id: props.value + Math.random().toString()
    });

    return {
      ...toRefs(state),
      helper
    }
  }
})
</script>
